import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import { PassiveDocumentCreationActions, UiActions } from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { RedirectService } from '../../../services/redirect.service';
import { StepsClientTypes, StepsNotClientTypes } from '../../../shared/enums';
import { AccountFormatService } from '../../../services/account-format.service';
import { DatePipe } from '@angular/common';
import { DataClientService } from '../../../services/data-client.service';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SuccessProcessHandler } from './handler/success-process.handler';
import { ResponseSuccessProcess } from '../../../shared/interfaces/successProcess.interface';
import { ContextService } from '../../../services/context.service';
import { TagPage } from '../../../store/actions/ui.actions';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-success-process',
  templateUrl: './success-process.component.html',
  styleUrls: ['../../../global.scss', './success-process.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SuccessProcessComponent implements OnInit, OnDestroy {
  @ViewChild('personalDataModal', { read: TemplateRef })
  personalDataModal: TemplateRef<any>;
  subs = new Subscription();
  @ViewChild('voucherPDF', { static: false }) voucherPDF: ElementRef;
  @ViewChild('t') tooltip: NgbTooltip;
  accountType: string;
  flowAccountName: string;
  identificationType: string;
  identificationNumber: string;
  identificationTypeJoint: string;
  identificationNumberJoint: string;
  name: string;
  surname: string;
  nameJoint: string;
  surnameJoint: string;
  currencyType: number;
  openingDate: string;
  isJointAccount: boolean;
  abr4Result: boolean;
  showCreatePassword: boolean;
  staticAssetsUrl = environment.staticScripts.staticAssets;
  staticBullets: string[];
  bullets$: ResponseSuccessProcess;
  mode = environment.mode;

  successTitle: string;
  successSubTitle: string;

  privateMode = false;
  dataService: DataNotClientService | DataClientService;

  public accountNumber: string;
  public accountCCI: string;

  private modalService: NgbModal;

  passiveDocumentCreation$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.passiveDocumentCreation)
  );

  constructor(
    public loadingService: LoadingService,
    public sessionService: SessionService,
    private contextService: ContextService,
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    private dataClientService: DataClientService,
    private accountFormatService: AccountFormatService,
    private redirectService: RedirectService,
    private datePipe: DatePipe,
    private successProcessHandler: SuccessProcessHandler
  ) {
    this.setService();
  }

  passiveDocumentCreationSuscription = this.passiveDocumentCreation$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    this.store.dispatch(PassiveDocumentCreationActions.cleanState());

    if (error != null) {
      const step = this.privateMode ? StepsClientTypes.STEP_OFFER : StepsNotClientTypes.STEP_OFFER;
      this.redirectService.setRedirect(step);
      return this.store.dispatch(UiActions.Navigate({ step }));
    }

    if (response != null && response.client.data) {
      this.downloadPDF(response.client.data.provisionContract.document.fileBase64, 'contrato_prestacion_servicios_bancarios_cartilla_informativa.pdf');
      this.loadingService.loading = false;
    }
  });

  ngOnInit() {
    document.getElementById('white-container').style.display = 'block';
    this.accountType = this.accountFormatService.getName();
    this.successProcessHandler.getBullets().subscribe((data) => {
      this.bullets$ = data;
      if (!this.dataNotClientService.getPasswordState()) {
        if (this.accountType === 'Ahorro') {
          this.bullets$.clasicaBullets.unshift(data.createPasswordText);
        } else if (this.accountType === 'Flex') {
          this.bullets$.falaBulletsPasswordFail.unshift(data.createPasswordText);
        }
      }
      this.setBullets();
    });
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
    this.accountCCI = this.dataService.getCCI();
    this.accountFormatService.getAccountNameFromAssets().subscribe((accountTitle) => {
      this.flowAccountName = accountTitle;
    });
    this.openingDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.currencyType = this.dataService.getCurrencyType();
    this.accountNumber = this.dataService.getAccountNumber();
    if (this.dataService.isIsJointAccount()) {
      this.identificationTypeJoint = this.dataService.getIdentificationTypeJoint();
      this.identificationNumberJoint = this.dataService.getIndentificationNumberJoint();
    }
    if (this.privateMode) {
      this.initForClientMode();
    } else {
      this.initForNoClientMode();
    }
  }

  ngOnDestroy() {
    this.passiveDocumentCreationSuscription.unsubscribe();
  }

  initForClientMode() {
    this.identificationType = this.dataService.getCigoData().documentoIdentidad.tipoDocumento;
    this.identificationNumber = this.dataService.getCigoData().documentoIdentidad.numeroDocumento;
    this.name = this.dataService.getCigoData().primerNombre;
    this.surname = this.dataService.getCigoData().apellidoPaterno;
    // JOINT ACCOUNT
    if (this.dataService.isIsJointAccount()) {
      this.isJointAccount = true;
      this.nameJoint = this.dataService.getCigoDataJoint().primerNombre;
      this.surnameJoint = this.dataService.getCigoDataJoint().apellidoPaterno;
    }
  }

  initForNoClientMode() {
    // set data for voucher
    this.identificationType = this.sessionService.customerIdentificationType;
    this.identificationNumber = this.sessionService.customerIdentificationNumber;

    // MAIN IS CLIENT
    if (this.dataNotClientService.getMainIsClient()) {
      this.name = this.dataService.getCigoData().primerNombre;
      this.surname = this.dataService.getCigoData().apellidoPaterno;
    } else if (this.dataService.clientIsForeign()) {
      this.name = this.dataNotClientService.getFullname();
      this.surname = this.dataNotClientService.getSurname();
    } else {
      if (this.dataNotClientService.getPioData()) {
        const pioData = this.dataNotClientService.getPioData();
        this.name = pioData.nombres;
      }
    }

    if (this.dataService.isIsJointAccount()) {
      this.isJointAccount = true;
      // JOINT IS CLIENT
      if (this.dataNotClientService.getJointIsClient()) {
        this.nameJoint = this.dataService.getCigoDataJoint().primerNombre;
        this.surnameJoint = this.dataService.getCigoDataJoint().apellidoPaterno;
      } else if (this.dataService.jointIsForeign()) {
        this.nameJoint = this.dataNotClientService.getFullnameJoint();
        this.surnameJoint = this.dataNotClientService.getSurnameJoint();
      } else {
        const pioData = this.dataNotClientService.getPioDataJoint();
        this.nameJoint = pioData?.nombres;
        this.surnameJoint = pioData?.apellidoPaterno;
      }
    }
  }

  downloadContract() {
    this.loadingService.loading = true;
    this.getPassiveDocumentCreation();
  }

  downloadPDF(pdf, fileName) {
    if (environment.isMobile) {
      this.modalService
        .open(this.personalDataModal, {
          ariaLabelledBy: 'modal-basic-title',
          windowClass: 'onboarding-pdf-data-modal',
          size: 'lg'
        })
        .result.then(
          (result) => {
            const closeResult = `Closed with: ${result}`;
          },
          (reason) => {}
        );
    }
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    downloadLink.remove();
  }

  getPassiveDocumentCreation() {
    const request = {};
    this.store.dispatch(PassiveDocumentCreationActions.getPassiveDocumentCreation({ request }));
  }

  setService() {
    this.privateMode = (environment.mode === 'IN' || environment.mode === 'PF') ? true : false;
    this.showCreatePassword = this.dataNotClientService.getPasswordState();
    this.dataService = this.privateMode ? this.dataClientService : this.dataNotClientService;
    if (!this.privateMode) {
      this.abr4Result = this.dataNotClientService.getRedirectToBranch();
    }
    const googleAnalytics = {
      is_joint_account: this.dataService.isIsJointAccount(),
      job_information: {
        workActivityType: this.dataService.getWorkActivityType() ? this.dataService.getWorkActivityType() : 'No informado',
        dateEntryWork: this.dataService.getDateEntryWork() ? this.dataService.getDateEntryWork() : 'No informado',
        companyName: this.dataService.getCompanyName() ? this.dataService.getCompanyName() : 'No informado',
        rucCompany: this.dataService.getRucCompany() ? this.dataService.getRucCompany() : 'No informado',
        profession: this.dataService.getProfession() ? this.dataService.getProfession() : 'No informado'
      },
      currency_account_type: this.dataService.getCurrencyType()
    };
    this.store.dispatch(TagPage({text: `checking-account-${this.accountFormatService.getName().toLowerCase()}-acquired`, extras: googleAnalytics}));
  }

  setBullets() {
    if (this.contextService.isPublicOmni1() && this.accountType === 'Ahorro') {
      this.successTitle = this.bullets$.clasicaTitle;
      this.successSubTitle = this.bullets$.clasicaSubTitle;
      this.staticBullets = this.bullets$.clasicaBullets;
    } else if (this.contextService.isPublicOmni1() && this.accountType === 'Flex') {
      this.successTitle = this.bullets$.falaTitle;
      this.successSubTitle = this.bullets$.falaSubTitle;
      this.staticBullets = !this.dataNotClientService.getPasswordState() ? this.bullets$.falaBulletsPasswordFail : this.bullets$.falaBulletsPasswordOk;
    } else if (this.contextService.isPrivateSite() && (this.accountType === 'Ahorro' || this.accountType === 'Flex')) {
      this.staticBullets = this.bullets$.privateBullets;
    } else if (this.contextService.isPrivateSite() && (this.accountType === 'AhorroSueldo')) {
      this.staticBullets = this.bullets$.salaryAccountBullets;
    } else if (this.contextService.isExecutiveMode() && (this.accountType === 'Ahorro' || this.accountType === 'Flex')) {
      this.staticBullets = this.bullets$.executiveBullets;
    } else {
      this.staticBullets = this.bullets$.ctsBullets;
    }
  }

  copyAccountNumber() {
    const copyValue = (this.privateMode || environment.mode === 'WEB-PF') ? this.accountNumber : this.accountCCI;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = copyValue;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.body.removeChild(selBox);
    navigator.clipboard.writeText(copyValue);
    this.showTooltip();
  }

  showTooltip() {
    this.tooltip.open();
    setTimeout(() => {
      this.tooltip.close();
    }, 1000);
  }
}
